import React, { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './styles.css';

const PhoneField = ({
  title,
  description,
  children,
  isEditing,
  onFieldChange,
  canEdit,
  googleProfileInfo
}) => {
  const [localValue, setLocalValue] = useState(children);

  // MinusIcon is used for empty fields
  const isMinusIcon =
    children.props?.className?.includes('fas fa-minus') ||
    (typeof children === 'string' && children === 'fas fa-minus');

  const handlePhoneChange = (e) => {
    const newValue = e.target.value;

    if (isMinusIcon) {
      setLocalValue(localValue);
    }

    if (isEditing && canEdit && !isMinusIcon) {
      setLocalValue(newValue);
      onFieldChange(newValue);
    }
  };

  return (
    <div className="space-y-2 min-w-0">
      <p className="text-sm sm:text-base font-semibold break-words">{title}</p>
      {description && (
        <p className="text-sm text-muted-foreground break-words">
          {description}
        </p>
      )}
      <div className="mt-2">
        {isEditing && canEdit && !isMinusIcon ? (
          <>
            <PhoneInput
              className="form-control phoneField client-profile input text-sm"
              placeholder="Enter phone number"
              value={googleProfileInfo?.primaryPhone}
              onChange={handlePhoneChange}
              defaultCountry="US"
            />
          </>
        ) : (
          <div className="text-sm sm:text-base break-words">
            {isEditing && canEdit && isMinusIcon ? (
              <>
                <PhoneInput
                  placeholder="Enter phone number"
                  value={''}
                  onChange={handlePhoneChange}
                  defaultCountry="US"
                />
              </>
            ) : (
              <>
                <span style={{ wordBreak: 'break-word' }}>{localValue}</span>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PhoneField;
